/**
 * 에러 코드
 *
 * @date 2018-12-20
 * @author mk.ko
 */

export function getErrorCodeInfo (code) {
  if (typeof code === 'undefined') {
    return
  }
  let res = {}

  // 장비 장애 이벤트
  if (code === 0) {
    res = {
      code: code,
      state: 'normal',
      msg: window.$nuxt.$t(`ec.0`)
    }
  } else {
    res = getDeviceErrorCodeInfo(code)
  }

  return res
}

function getCodeType (code) {
  // 끝 두자리 추출
  const textCode = code + ''
  const textLength = textCode.length
  return Number(textCode.substring(textLength - 2, textLength))
}
function convertErrorCodeDefault (code) {
  try {
    const result = Number(code)

    if ([code >= 277011000, code < 277012000].every(item => item)) return 277011000 // CPU
    else if ([code >= 277030000, code < 277040000].every(item => item)) { // VPN
      const type = getCodeType(code)
      if (type >= 30 && type < 40) return 277030030 // 인터페이스 VPN 회선 장애
    } else if ([code >= 277020010, code < 277030000].every(item => item)) { // 관리장비 I/F 상태
      const type = getCodeType(code)
      if (type >= 10 && type < 20) return 277020010 // 인터페이스 비정상
      else if (type >= 20 && type < 30) return 277020020 // 인터페이스 회선 비정상
      else if (type >= 30 && type < 40) return 277020030 // 인터페이스 트래픽 임계치 초과
    } else if ([code >= 277014000, code < 277015000].every(item => item)) return 277014000 // FAN  장애
    else if ([code >= 277015000, code < 277016000].every(item => item)) return 277015000 // PSU  장애
    else if ([code >= 278010000, code < 278011000].every(item => item)) return 278010000 // 장비 메시지 로그 검출
    else if ([code >= 278011000, code < 278012000].every(item => item)) return 278011000 // 장비 경고 로그 검출
    else if ([code >= 278020000, code < 278021000].every(item => item)) return 278020000 // 장비 프로세스 종료
    else if ([code >= 278021000, code < 278022000].every(item => item)) return 278021000 // 장비 프로세스 시작

    return result
  } catch (e) {
    window.$nuxt.$log('[Error convertErrorCodeDefault]: ', e)
    return code
  }
}

function getDeviceErrorCodeInfo (code) {
  const res = {}
  const errorCode = convertErrorCodeDefault(code) // 에러코드 보정 (범위 코드)

  // 장비 상태 아이콘 카테고리 계산
  switch (true) {
    case [277010001].includes(errorCode):
      res.state = 'normal'
      break
    // 277010300: 인증 실패, 277010310: 장비 연동 설정 변경, 277010400: 분산 실패, 277010000: 장비 응답 없음, 277010600: ?
    case [277010300, 277010310, 277010400, 277010000, 277010600].includes(errorCode):
      res.state = 'notResponse'
      break
    case [277010100].includes(errorCode): // 모니터링 실패
      res.state = 'noAnswer'
      break
    case [277010200].includes(errorCode): // 모니터링 사용 안함
      res.state = 'notUseMonitoring'
      break
    // 277011000: CPU 임계치 초과, 277012010: DISK(Log) 임계치 초과, 277012020: DISK(root) 임계치 초과, 277013000: 메모리 임계치 초과
    // 277013100: 세션 임계치 초과, 277020030: 인터페이스 트래픽 임계치 초과
    case [277011000, 277012010, 277012020, 277013000, 277013100, 277020030].includes(errorCode):
      res.state = 'warning'
      break
    // 277030010: VPN 서비스 비정상, 277030020: VPN 터널 장애, 277030040: VPN 경로 장애
    case [277030010, 277030020, 277030040].includes(errorCode):
      res.state = 'vpnFail'
      break
    case [277030030].includes(errorCode): // VPN 회선 장애
      res.state = 'vpnLineFail'
      break
    case [277030050].includes(errorCode): // VPN Bypass ** (NGF만 해당)
      res.state = 'vpnByPass'
      break
    case [277020010, 277020020].includes(errorCode): // 277020010: 인터페이스 비정상, 277020020: 인터페이스 회선 비정상
      res.state = 'lineAbnormal'
      break
    case [277014000].includes(errorCode): // FAN 장애
      res.state = 'fanFail'
      break
    case [277015000].includes(errorCode): // PSU 장애
      res.state = 'psuFail'
      break
    case [278030010].includes(errorCode): // 장비 콘솔 로그인 실패
      res.state = 'loginFail'
      break
    case [277010800].includes(errorCode): // 라이선스 체크, 초과, 만료
      res.state = 'licenseCheckFail'
      break
    default:
      res.state = 'warning'
  }

  res.code = code
  try {
    const eventCodes = window.$nuxt.$store.state.common.common.eventCodes
    res.msg = eventCodes.find(info => info.code === parseInt(code)).name
  } catch (e) {
    res.msg = `${window.$nuxt.$t('cmn.unknown')}(${code})`
  }

  return res
}
